import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, notification, Pagination, PaginationProps, TablePaginationConfig, Tabs } from 'antd';
import { FilterValue, SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  AllegationEsResponseInterface,
  AllegationInterface,
  AllegationService,
  AllegationStateInterface,
  AppealEsResponseInterface,
  AppealInterface,
  AppealService,
  AppealStateInterface,
  clearDecisionAction,
  clearDecisionListAction, clearNoteAction, DecisionEsResponseInterface, DecisionInterface, DecisionService,
  DecisionStateInterface,
  DKOMComplaintCardComponent,
  DKOMTableComponent, ESFilterInterface, FilterComponent,
  FullOrganizationUnitResponseInterfaceSingle,
  getAllAllegationsAction,
  getAllAppealsAction,
  getAllDecisionsAction,
  getAllSummarysAction,
  getScreenTagsByTypeAction,
  i18n, LicenceInterface, LicenceResponseInterfaceAll, LicenceResponseInterfaceSingle,
  LicenceService,
  LicenceUserResponseInterfaceAll,
  LicenceUserService, NavigationService, NoDataComponent, NoteResponseInterfaceAll,
  NoteService,
  OrganizationUnitService,
  QueryFilter, SelectTypeEnum, SorterInterface, StoreStateInterface, SummaryEsResponseInterface, SummaryInterface, SummaryService, SummaryStateInterface, TagScreenResponseInterface, TagScreenService, TagScreenStateInterface, UserRoleEnum
} from '../../../../common';
import DKOMAppealCardComponent from '../../../../common/components/cards/dkom/dkomAppealCards/dkomAppealCard.component';
import DKOMSummaryCardComponent from '../../../../common/components/cards/dkom/dkomSummaryCards/dkomSummaryCard.component';
import { LicenceEnum } from '../../../../common/enums/licence.enum';
import { AppRoutes } from '../../_router/app.routes';

function DKOMDecisionsPageComponent() {
  const dispatch = useDispatch();

  const userAuth = useSelector((state: StoreStateInterface) => state.auth);
  const decisions: DecisionStateInterface = useSelector((state: StoreStateInterface) => state.decision);
  const allegations: AllegationStateInterface = useSelector((state: StoreStateInterface) => state.allegation);
  const appeals: AppealStateInterface = useSelector((state: StoreStateInterface) => state.appeal);
  const summary: SummaryStateInterface = useSelector((state: StoreStateInterface) => state.summary);
  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);

  const [selectedTab, setSelectedTab] = useState('decision');
  const [filterValues, setFilterValues] = useState<ESFilterInterface | undefined>();

  const [dkomFilters, setDkomFilters] = useState<TagScreenResponseInterface[]>([]);
  const [vusFilters, setVusFilters] = useState<TagScreenResponseInterface[]>([]);

  const [esDataDecision, setEsDataDecision] = useState<DecisionEsResponseInterface>();
  const [esDataAllegation, setEsDataAllegation] = useState<AllegationEsResponseInterface>();
  const [esDataAppeal, setEsDataAppeal] = useState<AppealEsResponseInterface>();
  const [esDataSummary, setEsDataSummary] = useState<SummaryEsResponseInterface>();

  const [keyword, setKeyword] = useState('');

  const [esSearch, setEsSearch] = useState(true);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [orgUnitInfo, setOrgUnitInfo] = useState<FullOrganizationUnitResponseInterfaceSingle>();
  const [licenceData, setLicenceData] = useState<LicenceInterface>();
  const [allValidLicences, setAllValidLicences] = useState<LicenceInterface[]>([]);
  const [noteData, setNoteData] = useState<NoteResponseInterfaceAll>();

  const [sortBy, setSortBy] = useState<SorterInterface | undefined>();
  const [queryFilter, setQueryFilter] = useState<Array<QueryFilter>>(new Array<QueryFilter>());

  const [stopRender, setStopRender] = useState(false);

  const [exactMatch, setExactMatch] = useState<boolean>(true);

  useEffect(() => {
    clearNoteAction();
    NoteService.getAll(userAuth.user?.id, false).subscribe(
      (response: NoteResponseInterfaceAll) => {
        setNoteData(response);
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  }, [userAuth?.user?.id]);


  useEffect(() => {
    dispatch(clearDecisionAction());
    dispatch(clearDecisionListAction());
    dispatch(getScreenTagsByTypeAction('decision'));
    //dispatch(getAllDecisionsAction(undefined, `filter[active]=true`, 'sort=-id', `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`));
    esSearchFunctionDecision(false, { from: pageSize * (page - 1), size: pageSize });

    TagScreenService.getScreenTagsByType('decision').subscribe(
      (response: Array<TagScreenResponseInterface>) => {
        setDkomFilters(response);
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );

    TagScreenService.getScreenTagsByType('verdict').subscribe(
      (response: Array<TagScreenResponseInterface>) => {
        setVusFilters(response);
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (userAuth.user?.organizationUnit?.id) {
      OrganizationUnitService.getSingle(userAuth.user?.organizationUnit?.id).subscribe(
        (response: FullOrganizationUnitResponseInterfaceSingle) => {
          setOrgUnitInfo(response);
        },
        (error: Error) => {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      );
    }
  }, [userAuth.user]);

  useEffect(() => {
    if (orgUnitInfo?.data?.id) {
      LicenceService.getAll(undefined, `filter[organizationUnit.id]=${orgUnitInfo?.data?.id}`, 'sort=id', `page[offset]=0&page[limit]=999999`).subscribe(
        (response: LicenceResponseInterfaceAll) => {
          if (response?.data?.length) {
            let validLicences: LicenceInterface[] = [];

            response?.data?.forEach(licence => {
              if (licence.attributes?.licenceUsers?.find((x) => x.user?.id == userAuth.user?.id) && !licence.relationships?.licenceParent?.data && licence.attributes?.notesNum > 0) {
                setLicenceData(licence);
                const standardLicence = response.data.find(
                  (x) => x.attributes?.licenceUsers?.find((y) => y.user?.id == userAuth.user?.id) && !x.relationships?.licenceParent?.data && x.attributes?.active && x.attributes?.licenceType === LicenceEnum.STANDARD && licence.attributes?.notesNum > 0 && moment().isBefore(moment(licence?.attributes?.to).startOf('day'))
                );
                const premiumLicence = response.data.find(
                  (x) => x.attributes?.licenceUsers?.find((y) => y.user?.id == userAuth.user?.id) && !x.relationships?.licenceParent?.data && x.attributes?.active && x.attributes?.licenceType === LicenceEnum.PREMIUM && licence.attributes?.notesNum > 0 && moment().isBefore(moment(licence?.attributes?.to).startOf('day'))
                );
                if (standardLicence && standardLicence.attributes?.notesNum > 0) setLicenceData(standardLicence);
                if (premiumLicence && premiumLicence.attributes?.notesNum > 0) setLicenceData(premiumLicence);
              }
              if (licence.attributes?.licenceUsers?.find(x => x.user?.id == userAuth.user?.id) && !licence.relationships?.licenceParent?.data && licence.attributes?.active && moment().isBefore(moment(licence?.attributes?.to).startOf('day'))) {
                validLicences.push(licence);
              }
            });

            setAllValidLicences([...validLicences]);
          }
        },
        (error: Error) => {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      );
    }
  }, [orgUnitInfo?.data]);

  const prepareSupportedYears = () => {
    let supportedYears: { id: number | undefined; name: string; }[] = [];

    if (tags.tagScreens?.length) {
      tags.tagScreens?.forEach(tag => {
        if (tag.filter?.selectType === SelectTypeEnum.YEAR) {
          tag.children?.forEach(child => {
            supportedYears.push({id: child.tag?.id, name: child.tag?.name});
          });
        }
      });
    }

    return supportedYears;
  };

  const esSearchFunctionDecision = (allOpinions: boolean, pageSorted: { from: number, size: number }, keyword?: string, tagIds?: any, queryFilter?: Array<QueryFilter>, sort?: SorterInterface, supportedYears?: any) => {
    DecisionService.elasticSearch(allOpinions, pageSorted, exactMatch, keyword, queryFilter, tagIds, sort, supportedYears).subscribe(
      (response: DecisionEsResponseInterface) => {
        setEsDataDecision(response);
      },
      (error: any) => {
        if (error.errorId == 23) {
          notification['warning']({ message: i18n.translate('common.licence.noFilter'), duration: 2 });
        }
        else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      }
    );
  };

  const esSearchFunctionAllegation = (allOpinions: boolean, pageSorted: { from: number, size: number }, keyword?: string, tagIds?: any, supportedYears?: any) => {
    AllegationService.elasticSearch(allOpinions, pageSorted, exactMatch, keyword, tagIds, supportedYears).subscribe(
      (response: AllegationEsResponseInterface) => {
        setEsDataAllegation(response);
      },
      (error: any) => {
        if (error.errorId == 23) {
          notification['warning']({ message: i18n.translate('common.licence.noFilter'), duration: 2 });
        }
        else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      }
    );
  };

  const esSearchFunctionAppeal = (allOpinions: boolean, pageSorted: { from: number, size: number }, keyword?: string, tagIds?: any, supportedYears?: any) => {
    AppealService.elasticSearch(allOpinions, pageSorted, exactMatch, keyword, tagIds, supportedYears).subscribe(
      (response: AppealEsResponseInterface) => {
        setEsDataAppeal(response);
      },
      (error: any) => {
        if (error.errorId == 23) {
          notification['warning']({ message: i18n.translate('common.licence.noFilter'), duration: 2 });
        }
        else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      }
    );
  };

  const esSearchFunctionSummary = (allOpinions: boolean, pageSorted: { from: number, size: number }, keyword?: string, tagIds?: any, supportedYears?: any) => {
    SummaryService.elasticSearch(allOpinions, pageSorted, exactMatch, keyword, tagIds, supportedYears).subscribe(
      (response: SummaryEsResponseInterface) => {
        setEsDataSummary(response);
      },
      (error: any) => {
        if (error.errorId == 23) {
          notification['warning']({ message: i18n.translate('common.licence.noFilter'), duration: 2 });
        }
        else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      }
    );
  };

  const getTitle = () => {
    let str = '';
    if (selectedTab == 'decision') {
      str = i18n.translate('decisions.title');
    }
    if (selectedTab == 'allegation') {
      str = i18n.translate('allegations.title');
    }
    if (selectedTab == 'appeal') {
      str = i18n.translate('appeals.title');
    }
    if (selectedTab == 'summary') {
      str = i18n.translate('summarys.title');
    }

    return str;
  };

  const getTotal = () => {
    if (selectedTab == 'decision') {
      return esSearch ? esDataDecision?.totalHits : decisions?.decisions?.meta?.totalResourceCount
    }
    if (selectedTab == 'allegation') {
      return esSearch ? esDataAllegation?.totalHits : allegations?.allegations?.meta?.totalResourceCount
    }
    if (selectedTab == 'appeal') {
      return esSearch ? esDataAppeal?.totalHits : appeals?.appeals?.meta?.totalResourceCount
    }
    if (selectedTab == 'summary') {
      return esSearch ? esDataSummary?.totalHits : summary?.summarys?.meta?.totalResourceCount
    }
  };

  const refetch = (allValues: ESFilterInterface | undefined, tab?: string, columnFilter?: Array<QueryFilter>, sort?: SorterInterface, tableSearchAllowed?: boolean, stopRerender?: boolean) => {
    if (!checkLicenceYear()) {
      if (!tableSearchAllowed && allValidLicences?.length && !allValidLicences?.some(x => x.attributes?.licenceType === LicenceEnum.STANDARD) && !allValidLicences?.some(x => x.attributes?.licenceType === LicenceEnum.PREMIUM)) {
        notification['warning']({ message: i18n.translate('common.licence.noFilter'), duration: 4 });
        return;
      }
    }
    if ((!columnFilter || !columnFilter?.length) && !stopRerender) {
      setStopRender(true);
      setTimeout(() => {
        setStopRender(false);
      }, 0);
    }
    //setEsSearch(true);
    setFilterValues(allValues);
    setPage(1);
    if (tab === 'decision') {
      //dispatch(getAllDecisionsAction(allValues, `filter[active]=true`, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionDecision(false, { from: 0, size: pageSize }, keyword, allValues, columnFilter, sort, prepareSupportedYears());
    }
    if (tab === 'allegation') {
      //dispatch(getAllAllegationsAction(allValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionAllegation(false, { from: 0, size: pageSize }, keyword, allValues, prepareSupportedYears());
    }
    if (tab === 'appeal') {
      //dispatch(getAllAppealsAction(allValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionAppeal(false, { from: 0, size: pageSize }, keyword, allValues, prepareSupportedYears());
    }
    if (tab === 'summary') {
      //dispatch(getAllSummarysAction(allValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionSummary(false, { from: 0, size: pageSize }, keyword, allValues, prepareSupportedYears());
    }
  };

  const navigate = (tab: string) => {
    setSelectedTab(tab);
    //setEsSearch(false);
    setPage(1);
    setPageSize(20);
    if (tab === 'decision') {
      setEsDataDecision(undefined);
      dispatch(getScreenTagsByTypeAction('decision'));
      //dispatch(getAllDecisionsAction(filterValues, `filter[active]=true`, 'sort=-id', `page[offset]=0&page[limit]=20`));
      esSearchFunctionDecision(false, { from: 0, size: 20 }, undefined, filterValues, undefined, undefined);
    }
    if (tab === 'allegation') {
      setEsDataAllegation(undefined);
      dispatch(getScreenTagsByTypeAction('decision_appeal_allegation'));
      //dispatch(getAllAllegationsAction(filterValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=20`));
      esSearchFunctionAllegation(false, { from: 0, size: 20 }, undefined, filterValues, prepareSupportedYears());
    }
    if (tab === 'appeal') {
      setEsDataAppeal(undefined);
      dispatch(getScreenTagsByTypeAction('decision_appeal_response'));
      //dispatch(getAllAppealsAction(filterValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=20`));
      esSearchFunctionAppeal(false, { from: 0, size: 20 }, undefined, filterValues, prepareSupportedYears());
    }
    if (tab === 'summary') {
      setEsDataSummary(undefined);
      dispatch(getScreenTagsByTypeAction('decision_summary'));
      //dispatch(getAllSummarysAction(filterValues, undefined, 'sort=-id', `page[offset]=0&page[limit]=20`));
      esSearchFunctionSummary(false, { from: 0, size: 20 }, undefined, filterValues, prepareSupportedYears());
    }
  };

  const resetSearch = (tab?: string) => {
    setStopRender(true);
    setTimeout(() => {
      setStopRender(false);
    }, 0);
    localStorage.removeItem('transferFilters');
    //setEsSearch(false);
    setPage(1);
    setKeyword('');
    setFilterValues(undefined);
    if (tab === 'decision') {
      setEsDataDecision(undefined);
      //dispatch(getAllDecisionsAction(undefined, `filter[active]=true`, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionDecision(false, { from: 0, size: pageSize });
    }
    if (tab === 'allegation') {
      setEsDataAllegation(undefined);
      //dispatch(getAllAllegationsAction(undefined, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionAllegation(false, { from: 0, size: pageSize }, undefined, undefined, prepareSupportedYears());
    }
    if (tab === 'appeal') {
      setEsDataAppeal(undefined);
      //dispatch(getAllAppealsAction(undefined, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionAppeal(false, { from: 0, size: pageSize }, undefined, undefined, prepareSupportedYears());
    }
    if (tab === 'summary') {
      setEsDataSummary(undefined);
      //dispatch(getAllSummarysAction(undefined, undefined, 'sort=-id', `page[offset]=0&page[limit]=${pageSize}`));
      esSearchFunctionSummary(false, { from: 0, size: pageSize }, undefined, undefined, prepareSupportedYears());
    }
  };

  const onPaginationChange: PaginationProps['onChange'] = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);

    if (selectedTab === 'decision') {
      if (esSearch) {
        esSearchFunctionDecision(false, { from: pageSize * (page - 1), size: pageSize }, keyword, filterValues, queryFilter, sortBy, prepareSupportedYears());
      } else {
        //dispatch(getAllDecisionsAction(filterValues, `filter[active]=true`, 'sort=-id', `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`));
      }
    }
    if (selectedTab === 'allegation') {
      if (esSearch) {
        esSearchFunctionAllegation(false, { from: pageSize * (page - 1), size: pageSize }, keyword, filterValues, prepareSupportedYears());
      } else {
        //dispatch(getAllAllegationsAction(filterValues, undefined, 'sort=-id', `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`));
      }
    }
    if (selectedTab === 'appeal') {
      if (esSearch) {
        esSearchFunctionAppeal(false, { from: pageSize * (page - 1), size: pageSize }, keyword, filterValues, prepareSupportedYears());
      } else {
        //dispatch(getAllAppealsAction(filterValues, undefined, 'sort=-id', `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`));
      }
    }
    if (selectedTab === 'summary') {
      if (esSearch) {
        esSearchFunctionSummary(false, { from: pageSize * (page - 1), size: pageSize }, keyword, filterValues, prepareSupportedYears());
      } else {
        //dispatch(getAllSummarysAction(filterValues, undefined, 'sort=-id', `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`));
      }
    }
  };

  const keywordChanged = (value: string) => {
    setKeyword(value);
  };

  const exactMatchChanged = (exactMatch: boolean) => {
    setExactMatch(exactMatch);
  };

  const convertDataTypeDecision = (decisions: DecisionEsResponseInterface["hits"]): DecisionInterface[] => {
    return decisions?.map((decision) => {
      return {
        id: decision.id,
        type: decision.index,
        attributes: decision.source
      };
    })
  };

  const convertDataTypeAllegation = (allegations: AllegationEsResponseInterface["hits"]): AllegationInterface[] => {
    return allegations?.map((allegation) => {
      return {
        id: allegation.id,
        type: allegation.index,
        attributes: allegation.source
      };
    })
  };

  const convertDataTypeAppeal = (appeals: AppealEsResponseInterface["hits"]): AppealInterface[] => {
    return appeals?.map((appeal) => {
      return {
        id: appeal.id,
        type: appeal.index,
        attributes: appeal.source
      };
    })
  };

  const convertDataTypeSummary = (summarys: SummaryEsResponseInterface["hits"]): SummaryInterface[] => {
    return summarys?.map((summary) => {
      return {
        id: summary.id,
        type: summary.index,
        attributes: summary.source
      };
    })
  };

  const onTagsChange = (changedTags: any, allTags: any) => {
    localStorage.setItem('transferFilters', JSON.stringify(allTags));
  };

  const onChangeVus = (key: string) => {
    if (key == '2') {
      NavigationService.navigate(AppRoutes.VUS_DECLARATIONS.fullPath);
    }
  };

  const onChangeFilter = (pagination: TablePaginationConfig, filters: Record<string, FilterValue | null>, sorter: SorterResult<any> | SorterResult<any>[], extra: TableCurrentDataSource<any>): void => {
    let sort: SorterInterface | undefined;
    //@ts-ignore
    if (Object.keys(sorter).length > 0 && sorter.column !== undefined) {
      sort = {
        //@ts-ignore
        field: sorter.field.toString() === "verdict" ? "hasVerdict" : sorter.field.toString(),
        //@ts-ignore
        order: sorter.order === "descend" ? "Desc" : "Asc"
      }
    }
    let qf: Array<QueryFilter> = new Array<QueryFilter>();
    for (let key in filters) {
      if (filters[key] !== null && !!filters[key] && filters[key]!.length > 0) {
        if (key === 'type') {
          qf.push({ name: key, value: filters[key]! as number[]});
        } else {
          qf.push({ name: key, value: filters[key]![0].toString(), exactMatch: filters[key]![1] as boolean });
        }
      }
    }
    setQueryFilter(qf)
    setSortBy(sort)
    refetch(filterValues, 'decision', qf, sort, true, true)
  }

  const clearColumnFilters = () => {
    setQueryFilter([]);
    refetch(filterValues, 'decision', [], undefined, true)
  }

  const checkLicenceYear = () => {
    if (userAuth.user?.roles === UserRoleEnum.ADMIN) return true;

    if (allValidLicences?.length && allValidLicences?.some(x => x.attributes?.licenceType === LicenceEnum.PREMIUM)) {
      return true;
    } else {
      return false;
    }
  };

  const getAggregation = () => {
    if (selectedTab === 'decision') {
      return esDataDecision?.aggregation?.buckets;
    }
    if (selectedTab === 'allegation') {
      return esDataAllegation?.aggregation?.buckets;
    }
    if (selectedTab === 'appeal') {
      return esDataAppeal?.aggregation?.buckets;
    }
    if (selectedTab === 'summary') {
      return esDataSummary?.aggregation?.buckets;
    }
  };

  return (
    <div className="dkomDecisions w100-h100">
      <div className="dkomDecisions__breadcrumbs">
        <Breadcrumb>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>{i18n.translate('breadcrumbs.rh-practice')}</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>{i18n.translate('menu.dkom-decisions')}</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="dkomDecisions__admin">
        <div className="title">{i18n.translate('dkom.title')}</div>
      </div>
      <div className='dkomDecisions__tabs'>
        <Tabs onChange={onChangeVus} defaultActiveKey="1" size='large'>
          <Tabs.TabPane tab={i18n.translate('decisions.tabs.dkom')} key="1" />
          <Tabs.TabPane tab={i18n.translate('verdicts.tabs.vus')} key="2" />
        </Tabs>
      </div>
      {tags.tagScreens && tags.tagScreens.length && dkomFilters && dkomFilters.length && vusFilters && vusFilters.length ? (
        <FilterComponent
          aggregation={getAggregation()}
          filterAccess={checkLicenceYear()}
          //summaryFilterAccess={!(userAuth.user?.roles === UserRoleEnum.ADMIN || (licenceData && licenceData?.attributes?.licenceType === LicenceEnum.PREMIUM))}
          filters={tags.tagScreens}
          tab={selectedTab}
          onFilterChange={refetch}
          onTabChange={navigate}
          onFilterRemove={resetSearch}
          keyword={keyword}
          onKeywordChange={keywordChanged}
          onTagChange={onTagsChange}
          transferEnabled
          dkomFilters={dkomFilters}
          vusFilters={vusFilters}
          onExactMatchChange={exactMatchChanged}
          alternativeLayout
          hideFilter
        />
      ) : null}
      <div className="subtitle">{getTitle()}</div>
      {selectedTab == 'decision' && !stopRender ? (
        <DKOMTableComponent validLicences={allValidLicences} clearColumnFilters={clearColumnFilters} licenceData={licenceData} onChange={onChangeFilter} decisions={esSearch ? convertDataTypeDecision(esDataDecision?.hits as DecisionEsResponseInterface["hits"]) : decisions.decisions?.data} tags={tags.tagScreens} refreshTable={() => refetch(filterValues, 'decision')} />
      ) : null}
      {selectedTab == 'allegation' ? (
        !esSearch ? (
          allegations.allegations?.data?.length ? (
            [...(allegations.allegations?.data)].map((allegation, i) => (
              <DKOMComplaintCardComponent validLicences={allValidLicences} key={'complaint' + i} complaint={allegation} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        ) : (
          esDataAllegation?.hits?.length ? (
            [...(convertDataTypeAllegation(esDataAllegation?.hits))].map((allegation, i) => (
              <DKOMComplaintCardComponent validLicences={allValidLicences} key={'complaint' + i} complaint={allegation} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        )
      ) : null}
      {selectedTab == 'appeal' ? (
        !esSearch ? (
          appeals.appeals?.data?.length ? (
            [...(appeals.appeals?.data)].map((appeal, i) => (
              <DKOMAppealCardComponent validLicences={allValidLicences} key={'appeal' + i} appeal={appeal} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        ) : (
          esDataAppeal?.hits?.length ? (
            [...(convertDataTypeAppeal(esDataAppeal?.hits))].map((appeal, i) => (
              <DKOMAppealCardComponent validLicences={allValidLicences} key={'appeal' + i} appeal={appeal} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        )
      ) : null}
      {selectedTab == 'summary' ? (
        !esSearch ? (
          summary.summarys?.data?.length ? (
            [...(summary.summarys?.data)].map((summary, i) => (
              <DKOMSummaryCardComponent validLicences={allValidLicences} key={'summary' + i} summary={summary} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        ) : (
          esDataSummary?.hits?.length ? (
            [...(convertDataTypeSummary(esDataSummary?.hits))].map((summary, i) => (
              <DKOMSummaryCardComponent validLicences={allValidLicences} key={'summary' + i} summary={summary} licenceData={licenceData} notes={noteData} />
            ))
          ) : (
            <NoDataComponent />
          )
        )
      ) : null}
      <Pagination
        style={{ float: 'right', paddingTop: 16, paddingBottom: 16 }}
        onChange={onPaginationChange}
        showSizeChanger
        current={page}
        pageSize={pageSize}
        pageSizeOptions={['10', '20', '50', '100']}
        locale={{ items_per_page: `${i18n.t('pagination.perPage')}` }}
        total={getTotal()}
        responsive
        showTotal={(total) => `${i18n.t('pagination.total')}: ${total}`}
      />
    </div>
  );
}

export default DKOMDecisionsPageComponent;
